import React from "react";

/**
 * Landing page social-proof band.
 *
 * DELIBERATELY does NOT include fake customer logos or fake user counts.
 * Structure:
 *   1. "Early access" editorial eyebrow
 *   2. A founder quote (you rewrite this in your own voice)
 *   3. Reserved logo strip with "join the founding cohort" copy —
 *      swap the grey rectangles for real client logos once you have signed permission.
 */
export const SocialProof = () => {
  return (
    <section
      className="border-y border-slate-200 bg-white"
      data-testid="landing-social-proof"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
        {/* Editorial eyebrow */}
        <div className="text-center">
          <div className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.24em] text-emerald-700">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" />
            <span className="text-emerald-500/70">/</span>early_access
            <span className="text-slate-400">·</span>
            <span className="text-slate-500">Now onboarding early teams</span>
          </div>
        </div>

        {/* Founder quote — factual to founder's actual background */}
        <blockquote className="mt-10 mx-auto max-w-3xl text-center">
          <p className="text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900 leading-snug">
            &ldquo;I&rsquo;ve spent my career in FP&amp;A and RevOps, building the
            forecast every quarter.
            <span className="text-slate-500"> The honest answer was always &lsquo;ask me in six weeks.&rsquo;</span>{" "}
            I built Recrysta so no founder has to wait that long.&rdquo;
          </p>

          <footer className="mt-8 flex items-center justify-center gap-4">
            <div
              className="h-12 w-12 rounded-full bg-emerald-100 ring-2 ring-emerald-500/30 flex items-center justify-center text-emerald-800 font-bold text-sm"
              data-testid="landing-founder-avatar"
              aria-label="Founder initials"
            >
              PP
            </div>
            <div className="text-left">
              <div className="text-sm font-bold text-slate-900">Piyush Pokharkar</div>
              <div className="text-xs text-slate-500">Founder, Recrysta</div>
            </div>
          </footer>
        </blockquote>

        {/* Founding cohort — single line, no empty logo grid */}
        <div className="mt-14 text-center">
          <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400 mb-3">
            <span className="text-emerald-500/70">/</span>founding_cohort
          </div>
          <p className="text-sm text-slate-600 max-w-xl mx-auto leading-relaxed" data-testid="landing-founding-cohort-line">
            6 spots. Lifetime access to new features at your original price,
            plus direct-to-founder support.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
